import request from '@/utils/request'

//Login
export function loadUnilvl_summary(params) {
  return request({ url: 'vunilevel', method: 'post', data: params })
} 
